__turbopack_context__.v({
  "brandAndComparison": "Product-module-scss-module__CPaCiG__brandAndComparison",
  "brandURL": "Product-module-scss-module__CPaCiG__brandURL",
  "buyZone": "Product-module-scss-module__CPaCiG__buyZone",
  "carousel": "Product-module-scss-module__CPaCiG__carousel",
  "copyButton": "Product-module-scss-module__CPaCiG__copyButton",
  "dealsBannerContainer": "Product-module-scss-module__CPaCiG__dealsBannerContainer",
  "infoBanner": "Product-module-scss-module__CPaCiG__infoBanner",
  "infoBannerContainer": "Product-module-scss-module__CPaCiG__infoBannerContainer",
  "infoVideoContainer": "Product-module-scss-module__CPaCiG__infoVideoContainer",
  "outfittingAnchorContainer": "Product-module-scss-module__CPaCiG__outfittingAnchorContainer",
  "outfittingTileContainer": "Product-module-scss-module__CPaCiG__outfittingTileContainer",
  "pdp2026LeftColumnFixed": "Product-module-scss-module__CPaCiG__pdp2026LeftColumnFixed",
  "pdp2026LeftColumnScrolling": "Product-module-scss-module__CPaCiG__pdp2026LeftColumnScrolling",
  "pdp2026RightColumn": "Product-module-scss-module__CPaCiG__pdp2026RightColumn",
  "pdp2026RightColumnFixed": "Product-module-scss-module__CPaCiG__pdp2026RightColumnFixed",
  "pdpContainer": "Product-module-scss-module__CPaCiG__pdpContainer",
  "pdpContainer2026": "Product-module-scss-module__CPaCiG__pdpContainer2026",
  "pdpContainerGalleryFirst": "Product-module-scss-module__CPaCiG__pdpContainerGalleryFirst",
  "pdpContainerOutOfStock": "Product-module-scss-module__CPaCiG__pdpContainerOutOfStock",
  "pdpOuterContainer2026": "Product-module-scss-module__CPaCiG__pdpOuterContainer2026",
  "pdpOuterContainer2026Enabled": "Product-module-scss-module__CPaCiG__pdpOuterContainer2026Enabled",
  "priceReviewContainerInStock": "Product-module-scss-module__CPaCiG__priceReviewContainerInStock",
  "priceReviewsContainer": "Product-module-scss-module__CPaCiG__priceReviewsContainer",
  "productCode": "Product-module-scss-module__CPaCiG__productCode",
  "productCodeOutOfStock": "Product-module-scss-module__CPaCiG__productCodeOutOfStock",
  "productComparisonContainer": "Product-module-scss-module__CPaCiG__productComparisonContainer",
  "productComparisonHeader": "Product-module-scss-module__CPaCiG__productComparisonHeader",
  "productComparisonSection": "Product-module-scss-module__CPaCiG__productComparisonSection",
  "productComparisonTitle": "Product-module-scss-module__CPaCiG__productComparisonTitle",
  "productInfo": "Product-module-scss-module__CPaCiG__productInfo",
  "productInfoAccordionHeading": "Product-module-scss-module__CPaCiG__productInfoAccordionHeading",
  "productName": "Product-module-scss-module__CPaCiG__productName",
  "productNotesHeading": "Product-module-scss-module__CPaCiG__productNotesHeading",
  "productPriceAndReviewsContainer": "Product-module-scss-module__CPaCiG__productPriceAndReviewsContainer",
  "productTagsContainer": "Product-module-scss-module__CPaCiG__productTagsContainer",
  "qcText": "Product-module-scss-module__CPaCiG__qcText",
  "reviewAndAnswer": "Product-module-scss-module__CPaCiG__reviewAndAnswer",
  "reviewsAndAnswersContainer": "Product-module-scss-module__CPaCiG__reviewsAndAnswersContainer",
  "sidebar": "Product-module-scss-module__CPaCiG__sidebar",
  "skeleton": "Product-module-scss-module__CPaCiG__skeleton",
  "skeletonBreadcrumbs": "Product-module-scss-module__CPaCiG__skeletonBreadcrumbs",
  "skeletonImage": "Product-module-scss-module__CPaCiG__skeletonImage",
  "skeletonText": "Product-module-scss-module__CPaCiG__skeletonText",
  "sliceZoneLoading": "Product-module-scss-module__CPaCiG__sliceZoneLoading",
  "stickyInnerWrapper": "Product-module-scss-module__CPaCiG__stickyInnerWrapper",
});
